import { render } from "./WishlistLogin.vue?vue&type=template&id=90fb0c2c&scoped=true"
import script from "./WishlistLogin.vue?vue&type=script&lang=js"
export * from "./WishlistLogin.vue?vue&type=script&lang=js"

import "./WishlistLogin.vue?vue&type=style&index=0&id=90fb0c2c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90fb0c2c"]])

export default __exports__